module.exports = __webpack_public_path__ + "images/collections/collections-grey.45eba761fd1b4ae1c8ff.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/collections/collections-grey.svg
// module id = 53yk
// module chunks = 1